import { saveAs } from 'file-saver';

/**
 * Trigger a browser download of a blob using the given file name verbatim.
 * The blob is expected to carry its own content type and the file name its
 * own extension (e.g. a download served with a `Content-Disposition` header).
 */
export const saveBlob = (data: Blob, fileName: string): void => {
  saveAs(data, fileName);
};
